import Search from "../components/search/Search";

const SearchPage = () => {
 return (
  <Search/>
 )}

export default SearchPage;